import { camelize, snakeize } from 'casing'
import { DateTime } from 'luxon'
import {
  FlyoutOnboardingSectionName,
  type ProcessFlyoutOnboardingParams,
} from '../types'
import { checkAllCompleted } from './checkAllCompleted'

export const processFlyoutOnboarding = ({
  isAutoSave,
  onboardingForm,
  pageMarkerMapping,
  page,
  status,
  isFormUpdated,
  partnerId,
}: ProcessFlyoutOnboardingParams) => {
  const { cloudSettings, ...restOnboardingForm } = onboardingForm
  const { currencies, ...restCloudSettings } = cloudSettings || {}

  const cloudSettingsWithAutomationRule = restCloudSettings
    ? {
        ...restCloudSettings,
        automation: !(restCloudSettings.isOwnS3Bucket ?? false),
      }
    : restCloudSettings

  const cleanedCloudSettings = cloudSettingsWithAutomationRule
    ? Object.fromEntries(
        Object.entries(cloudSettingsWithAutomationRule).filter(
          ([key]) => key !== 'sellerType'
        )
      )
    : cloudSettingsWithAutomationRule

  const cloudSettingsForSave = cleanedCloudSettings
    ? {
        ...cleanedCloudSettings,
        cloudExternalId: String(partnerId).trim(),
      }
    : cleanedCloudSettings

  const snakeizedData = snakeize({
    ...restOnboardingForm,
    cloudSettings: cloudSettingsForSave,
    lockMetadata: {
      ...onboardingForm.lockMetadata,
      ...(isFormUpdated || status === 'lockAcquire'
        ? { lastActivityAt: DateTime.now().toUTC().toISO() }
        : {}),
      editingEnabled: true,
    },
    ...(!isAutoSave && {
      pageMarker: {
        ...onboardingForm.pageMarker,
        [camelize(pageMarkerMapping[page])]: true,
      },
      completed: {
        value: checkAllCompleted({
          pageMarker: onboardingForm[FlyoutOnboardingSectionName.PAGE_MARKER],
          page,
          isManaged:
            onboardingForm[FlyoutOnboardingSectionName.LABRA_PARTNER_DETAILS]
              .isManaged,
        }),
      },
    }),
  })

  if (currencies && snakeizedData.cloud_settings) {
    snakeizedData.cloud_settings.cloud_currencies = currencies
  }

  return snakeizedData
}
